import React from "react";

import { ClassGroupType } from "./Style.types";

const StyleContext = React.createContext<ClassGroupType<any>>({});

interface StyleProviderProps extends React.PropsWithChildren {
  classGroups: ClassGroupType<any>;
}

const StyleProvider = ({ classGroups, children }: StyleProviderProps) => (
  <StyleContext.Provider value={classGroups}>{children}</StyleContext.Provider>
);

const useStyles = () => React.useContext(StyleContext);

export { StyleProvider, useStyles };
